﻿const axios = require('axios');
import InputFloatLabel from '@components/input-labels';

class Account {
    Init() {
        var me = this;
        $("#account-edit-profile").css("display", "none");
        $("#account-edit").click(function (event) {
            event.preventDefault();
            $("#account-view-profile").css("display", "none");
            $("#account-edit-profile").css("display", "block");
        });

        var $error = $("#account-edit-profile").find("form").find(".field-validation-error").first()[0];
        if ($error) {
            var validationError = $error.innerHTML;
            if (validationError !== undefined) {
                $("#account-view-profile").css("display", "none");
                $("#account-edit-profile").css("display", "block");
            }
        }

        $('#account-edit-profile').on('click', '.btn-save-account-info', function (event) {
            event.preventDefault();
            me.UpdateAccountInfo($(this));
        });

    }

    UpdateAccountInfo(e) {
        let form = $(e).closest("form");
        let bodyFormData = new FormData();
        bodyFormData.set('FirstName', $("#FirstName", form).val());
        bodyFormData.set('LastName', $("#LastName", form).val());
        bodyFormData.set('PhoneNumber', $("#PhoneNumber", form).val());
        bodyFormData.set('PreferredLanguage', $("#PreferredLanguage", form).val());
        bodyFormData.set('__RequestVerificationToken', $("input[name=__RequestVerificationToken]", form).val());
        const headers = { 'Content-Type': 'application/json' }

        axios.post(form[0].action, bodyFormData, {
            headers: headers
        })
            .then(function (response) {
                var firstName = $('#FirstName-error');
                var lastName = $('#LastName-error');

                if (response.data.success == false) {
                    var errorMessage = $(".account-page-forms__top-error-message");

                    if (errorMessage) {
                        errorMessage.innerText = '';
                        for (var error in response.data.errors) {

                            if (response.data.errors[error].key === "FirstName") {
                                firstName.text(response.data.errors[error].value);
                                firstName.parent().addClass('form-error');
                            }
                            if (response.data.errors[error].key === "LastName") {
                                lastName.text(response.data.errors[error].value);
                                lastName.parent().addClass('form-error');
                            }

                            if (response.data.errors[error].key === "ProfilePageViewModel.Error") {
                                errorMessage.style.display = "block";
                                $(".account-page-forms__top-error-message").append(response.data.errors[error].value);
                            }

                            if (response.data.errors[error].key === undefined ||
                                response.data.errors[error].key === '') {
                                errorMessage.style.display = "block";
                                $(".account-page-forms__top-error-message")
                                    .append(response.data.errors[error] + '<br />');
                            }

                        }
                    }

                } else {
                    $(".form-error-information").text("");
                    $("#lbl-first-name").text($("#FirstName", form).val());
                    $("#lbl-last-name").text($("#LastName", form).val());
                    $("#lbl-phone").text($("#PhoneNumber", form).val());
                    $("#lbl-preferred-language").text($("#PreferredLanguage", form).val().toUpperCase());
                    $("#account-view-profile").css("display", "block");
                    $("#account-edit-profile").css("display", "none");

                    var welcomeTag = $("#welcome-text");
                    welcomeTag.text(welcomeTag.data("text") + " " + $("#FirstName", form).val() + "!");
                    
                    InputFloatLabel.Rebind();
                }

                //RESET
                if (firstName.text() === '') {
                    firstName.parent().removeClass('form-error');
                }
                if (lastName.text() === '') {
                    lastName.parent().removeClass('form-error');
                }
            })
            .catch(function (response) {
                $(".account-page-forms__top-error-message").text(response);
            });
    }
}

var account = new Account();
account.Init();